import { useState, useEffect } from "react";

export const useScreenHeight = () => {
	const [screenHeight, setScreenHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => {
			setScreenHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return screenHeight;
};

// Utility function to calculate the chart height
export const getChartHeight = screenHeight => {
	// If the screen is less than 530px high, use 320px
	// Otherwise, use the normal height of 400px
	return screenHeight < 530 ? 320 : 400;
};
